import ReferencePathService from '~/services/referencePathServices/referencePathService'
import {IReferencePathNodeObjectModel, IReferencePathNodeSpecific} from '~/interfaces/referencePathInterfaces'
import ObjectModel from "~/models/objectModel"
import {ReferenceNodeType} from '~/enums/referenceNodeType'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'

export default class ObjectModelPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.ObjectModel

  constructor(private objectModelNode: IReferencePathNodeObjectModel) {
    super()
  }

  get label(): string {
    return this.objectModelNode.reference()?.titleOrDefault
  }

  get nodes(): IReferencePathNodeObjectModel[] {
    return [this.objectModelNode]
  }

  reference(): ObjectModel {
    return ObjectModel.repo.findById(this.objectModelNode.reference_id)
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    if (!node) return true // it's valid to have nothing to link to

    let objectModel: ObjectModel;
    let decision: boolean
    switch (node.reference_type) {
      case ReferenceNodeType.ObjectModelRelation:
        const relation = node.service.reference()
        if (relation) {
          if (node.inverse) {
            decision = relation.related_object_model_ids.includes(this.objectModelNode.reference_id)
          } else {
            decision = relation.object_model_id === this.objectModelNode.reference_id
          }
        }
        break
      case ReferenceNodeType.ObjectModelProperty:
        objectModel = this.reference();
        if (objectModel) {
          decision = objectModel.objectModelPropertyHandler.all.some(x => x.id === node.reference_id)
        }
        break
      case ReferenceNodeType.RecordHolder:
        decision = true
        break
      case ReferenceNodeType.ObjectModelLinkedForm:
        objectModel = this.reference();
        if (objectModel) {
          decision = objectModel.object_model_linked_forms.some(formData => formData.id === node.reference_id);
        }
        break;
      default:
        decision = false
        break
    }
    this.debugCanLinkTo('ObjectModelPathService', this.objectModelNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return false
  }

  get referenceIsInitializable(): boolean {
    return true;
  }

}